'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * AbstractStack
 *
 * Provides a shared set of functionality to all navigation stack components
 * Stores stack components for access outside of the stack
 */
var AbstractStack = function (_React$Component) {
  (0, _inherits3.default)(AbstractStack, _React$Component);

  /**
   * @param {Object} props Properties provided by react
   *
   * @return {AbstractStack}
   */
  function AbstractStack(props) {
    (0, _classCallCheck3.default)(this, AbstractStack);

    /** @access private */
    var _this = (0, _possibleConstructorReturn3.default)(this, (AbstractStack.__proto__ || (0, _getPrototypeOf2.default)(AbstractStack)).call(this, props));

    _this.defaultComponents = {};
    return _this;
  }

  /**
   * Get Components with any overrides in place
   *
   * @protected
   *
   * @returns {Object} Key Value for components
   */


  (0, _createClass3.default)(AbstractStack, [{
    key: 'getComponents',
    value: function getComponents() {
      var components = this.props.components;


      var overrides = components.reduce(function (result, config) {
        return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, config.override, config.component));
      }, {});

      // Extend the default components with the provided child overrides
      return _bdcoreUtilities.ComponentCollection.setComponents(this.defaultComponents, overrides).getComponents();
    }

    /**
     * Get raw Components as constructor functions
     *
     * @protected
     *
     * @return {Array<React.Component>}
     */

  }, {
    key: 'getRawComponents',
    value: function getRawComponents() {
      if (!_bdcoreUtilities.ComponentCollection.hasComponents()) {
        this.getComponents();
      }

      return _bdcoreUtilities.ComponentCollection.getRawComponents();
    }
  }, {
    key: 'getComponentProps',
    value: function getComponentProps(matchComponent) {
      var _ref = this.props.components.find(function (c) {
        return c.component === matchComponent;
      }) || {},
          override = _ref.override,
          component = _ref.component,
          props = (0, _objectWithoutProperties3.default)(_ref, ['override', 'component']);

      return props;
    }

    /**
      * Get extended routes
      *
      * @protected
      *
      * @return {Array<React.Component>}
      */

  }, {
    key: 'getExtendedRoutes',
    value: function getExtendedRoutes() {
      return (this.props.routes || []).filter(function (v) {
        return v;
      });
    }
  }]);
  return AbstractStack;
}(_react2.default.Component);

AbstractStack.propTypes = {
  components: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    override: _propTypes2.default.string.isRequired,
    component: _propTypes2.default.func.isRequired,
    filters: _propTypes2.default.object
  })),
  routes: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

AbstractStack.defaultProps = {
  components: [],
  routes: []
};

exports.default = AbstractStack;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-navigation-stacks/build/AbstractStack.js
// module id = 225
// module chunks = 0